import {
  CATALOG_PAGE_LIMIT_MAX,
  type SortType,
} from "@/features/catalog/stores/catalogStore";
import { boardApiPath } from "@/shared/api/boardPath";

export function getCatalogPath(
  sortType: SortType,
  page: number,
  limit: number,
  seed?: number,
): string {
  return `${boardApiPath("/catalog")}${catalogQuery(sortType, page, limit, seed)}`;
}

/** 総合カタログが任意板のカタログを引くためのslug明示版。 */
export function getBoardCatalogPath(
  slug: string,
  sortType: SortType,
  page: number,
  limit: number,
  seed?: number,
): string {
  return `/catalog/${encodeURIComponent(slug)}${catalogQuery(sortType, page, limit, seed)}`;
}

/**
 * 制御なし群向けのサーバーサイド混合カタログ。bは板slugをカンマ区切りで渡し、
 * 板をまたいだ並び順とページングをbackendが保証する。
 */
export function getCatalogMixPath(
  slugs: readonly string[],
  sortType: SortType,
  page: number,
  limit: number,
  seed?: number,
): string {
  const boards = slugs.map((slug) => encodeURIComponent(slug)).join(",");
  return `/catalog-mix${catalogQuery(sortType, page, limit, seed)}&b=${boards}`;
}

function catalogQuery(
  sortType: SortType,
  page: number,
  limit: number,
  seed?: number,
): string {
  const normalizedPage = Number.isFinite(page)
    ? Math.max(1, Math.floor(page))
    : 1;
  const normalizedLimit = Number.isFinite(limit)
    ? Math.max(1, Math.min(CATALOG_PAGE_LIMIT_MAX, Math.floor(limit)))
    : CATALOG_PAGE_LIMIT_MAX;
  const seedQuery =
    sortType === "random" &&
    seed !== undefined &&
    Number.isSafeInteger(seed) &&
    seed >= 0 &&
    seed <= 2_147_483_647
      ? `&seed=${seed}`
      : "";
  return `?sort=${sortType}&page=${normalizedPage}&limit=${normalizedLimit}${seedQuery}`;
}
